import PropTypes from 'prop-types'
import Button from '../../shared/components/Button/Button'
import sanitizedContentData from '../../shared/utils/sanitizedContentData'
import { motion } from 'framer-motion'
import { useMemo } from 'react'
// import { TimelineContext } from './Timeline'

const TimelineContent = ({ content, next, previous, controls, isFirst, isLast, externalWidth }) => {
  const width = useMemo(() => externalWidth, [externalWidth])
  // const controls = useAnimationControls()
  return (
    <motion.div animate={controls} className="timeline-body-container">
      {width <= 1020 && (
        <div className="w-full col-span-12 pb-[30px] mr-[30px] flex flex-row justify-end">
          <h4 className="heading4 text-eerie-black-light">{content?.event?.page}</h4>
        </div>
      )}
      <div className="container-left">
        <pre>{content?.event?.year}</pre>
        <h2>{content?.event?.title}</h2>
        <div className="description">
          <p dangerouslySetInnerHTML={sanitizedContentData(content?.event?.description)}></p>
        </div>
        <div className="actions">
          <Button
            showLabel={false}
            type={'icon'}
            iconWidth={'56px'}
            iconHeight={'56px'}
            link={''}
            iconStroke={isFirst ? '#adadad' : '#1B1F24'}
            strokeCircle={isFirst ? '#adadad' : '#1B1F24'}
            icon={'ArrowLeft'}
            action={!isFirst ? previous : () => {}}
          />
          <Button
            showLabel={false}
            type={'icon'}
            iconHeight={'56px'}
            iconWidth={'56px'}
            link={''}
            icon={'ArrowRight'}
            iconStroke={isLast ? '#adadad' : '#1B1F24'}
            strokeCircle={isLast ? '#adadad' : '#1B1F24'}
            action={!isLast ? next : () => {}}
          />
        </div>
        {/* {width < 1020 && (
          <div className="date-event">
            <h3>{parseMobileDate(content?.event?.date)}</h3>
          </div>
        )} */}
      </div>
      <div className="container-right">
        <div className="event-image-container">
          <img
            src={content?.event?.event_picture?.url ?? ''}
            alt={content?.event?.event_picture?.alt ?? 'AIC Timeline Event Picture'}
          />
        </div>
      </div>
    </motion.div>
  )
}

TimelineContent.propTypes = {
  content: PropTypes.object,
  externalWidth: PropTypes.number,
  next: PropTypes.func,
  previous: PropTypes.func,
  controls: PropTypes.object,
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool,
}

export default TimelineContent
